import { Phone, Mail, Clock } from "lucide-react";
import { CONTACT } from "@/lib/site";

export default function UtilityBar() {
  return (
    <div data-testid="utility-top-bar" className="bg-[var(--navy-dark)] text-white text-xs sm:text-[13px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-10 flex items-center justify-between gap-4">
        <div className="flex items-center gap-5 sm:gap-7">
          <a data-testid="utility-phone-link" href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-red-300 transition-colors">
            <Phone className="w-3.5 h-3.5 text-[#ff6b70]" /> {CONTACT.phone}
          </a>
          <a data-testid="utility-email-link" href={`mailto:${CONTACT.email}`} className="hidden sm:flex items-center gap-2 hover:text-red-300 transition-colors">
            <Mail className="w-3.5 h-3.5 text-[#ff6b70]" /> {CONTACT.email}
          </a>
        </div>
        <div className="flex items-center gap-2 text-white/80">
          <Clock className="w-3.5 h-3.5 text-[#ff6b70]" />
          <span data-testid="utility-hours" className="hidden md:inline">{CONTACT.hours}</span>
          <span className="md:hidden">24/7 Support</span>
        </div>
      </div>
    </div>
  );
}
